<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-table ref="dataTable" :data="articles" stripe :default-expand-all="false" :expand-row-keys="expandkeys" :row-key="getRowKeys" style="width: 100%">
            <el-table-column type="index" width="50" label="序号" align="center">
              <template slot-scope="scope">{{ (currentPage - 1) * pageSize + 1 + scope.$index }} </template>
            </el-table-column>

            <el-table-column prop="sn" label="稿件编号" align="center" width="90">
              <template slot-scope="scope">
                <p class="sn">{{ scope.row.sn }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="150">
              <template slot-scope="scope">
                <h3 class="title" @click="showProcess(scope.row.id)">{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"> </el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="step" label="状态描述">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.step == 61 || scope.row.step == 40 || scope.row.step == 51" type="warning">{{ getStatusText(scope.row.step) }}</el-tag>
                <el-tag v-else>{{ getStatusText(scope.row.step) }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="pt" label="操作" width="220" align="center" fixed="right">
              <template slot-scope="scope">
                <div style="text-align: right">
                  <el-button v-if="scope.row.step == 21 || scope.row.step == 51 || scope.row.step == 61" type="primary" size="mini" @click="articleUpload(scope.row.id)">进行改稿</el-button>
                  <el-button v-else-if="scope.row.step == 40 && $config.isCharge" type="primary" size="mini" @click="paySGF(scope.row.id)">缴纳费用</el-button>
                  <el-button v-else-if="scope.row.step == 53" type="primary" size="mini" @click="paySGF(scope.row.id)">上传许可书</el-button>
                  <el-button size="mini" @click="revokeArticle(scope.row.id)">主动撤稿</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px" v-show="total > 0">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="currentPage" @current-change="pageChange"> </el-pagination>
      </el-row>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div style="padding: 0 20px 20px 20px">
        <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="USER" @processSuccess="processSuccess"></ArticleProcess>
      </div>
    </el-drawer>

    <!--el-dialog title="撤稿提示" :visible.sync="dialogVisible" width="480px">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </!--el-dialog-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import authorApi from "@/api/author"

export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      dialogVisible: false,
      headLinks: [{ path: "", title: "投稿中稿件" }],
      drawer: false,
      drawerTitle: "",
      articles: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      curArticleId: 0,
      expandkeys: [],
      getRowKeys(row) {
        return row.id
      },
    }
  },

  created() {
    this.loadArticles()
  },

  mounted() {
    //let firstRow = this.articles[1];
    /* setTimeout(()=>{
      //this.$refs.dataTable.toggleRowExpansion(firstRow,false);
      //this.expandkeys = [];
    },2000); */
  },

  methods: {
    getStatusText(step) {
      for (let i = 0; i < this.$config.steps.length; i++) {
        if (step == this.$config.steps[i].step) {
          return this.$config.steps[i].title
        }
      }
      return ""
    },

    getStep(step) {
      var sw = parseInt(step / 10)
      var gw = step % 10
      var index = 1
      let arr = ["投稿", "编辑审稿", "支付出版费", "专家审稿", "查重", "完成"]

      if (sw == 2) {
        if (gw == 0) {
          index = 1
        } else if (gw == 1) {
          arr[1] = "编辑首次审稿"
          arr.splice(2, 0, "作者改稿")
          index = 2
        } else if (gw == 2) {
          arr[1] = "编辑首次审稿"
          arr.splice(2, 0, "作者改稿")
          arr.splice(3, 0, "编辑审稿")
          index = 3
        }
      } else if (sw == 3) {
        index = 2
      } else if (sw == 4) {
        if (gw == 0) {
          index = 3
        } else if (gw == 1) {
          arr[3] = "专家审稿"
          arr.splice(4, 0, "作者改稿")
          index = 4
        } else if (gw == 2) {
          arr[3] = "专家审稿"
          arr.splice(4, 0, "作者改稿")
          arr.splice(5, 0, "专家审稿")
          index = 5
        }
      } else {
        index = sw - 1
      }

      return {
        index: index,
        data: arr,
      }
    },

    loadArticles() {
      this.articles = []
      authorApi.myArticleRuningList(-1, -1, "optTime", "DESC", this.currentPage, this.pageSize).then((res) => {
        for (let i = 0; i < res.rows.length; i++) {
          let item = res.rows[i]
          let stepData = this.getStep(item.step)
          item.stepIndex = stepData.index
          item.stepData = stepData.data
          this.articles.push(item)
        }
        this.total = res.total
      })
    },

    revokeArticle(articleId) {
      let msg = this.$config.isCharge ? "你是否确定主动撤稿?撤稿后请进入“被退稿稿件”申请退款" : "你是否确定主动撤稿?"
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          authorApi.revokeArticle(articleId, 1).then((res) => {
            if (res.code == 0) {
              this.$notify({ title: "成功", message: "主动撤稿成功", type: "success" })
              this.loadArticles()
              this.getStat()
            } else {
              this.$notify.error({ title: "错误", message: res.msg })
            }
          })
        })
        .catch(() => {})
    },

    openDraw(title) {
      this.drawer = true
      this.drawerTitle = title
    },

    showProcess(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    paySGF(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    articleUpload(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    processSuccess() {
      setTimeout(() => {
        this.loadArticles()
      }, 1000)
    },

    pageChange(curPage) {
      this.currentPage = curPage
      this.loadArticles()
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  margin: 0 auto 45px auto;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;

  .info {
    flex: 1;
    display: flex;

    .sn {
      color: #fff;
      background-color: #409eff;
      margin: 5px;
      line-height: 30px;
      padding: 0 10px;
    }

    .createTime {
      padding: 0 10px;
      font-size: 14px;
      line-height: 26px;
    }

    .title {
      padding: 0 10px;
      line-height: 40px;
      font-weight: bold;
      flex: 1;
    }

    .opt {
      padding: 5px;
    }
  }
}

.title {
  cursor: pointer;
  text-decoration: underline;
}

.sn {
  font-family: "Courier New", Courier, monospace;
  /*font-family: 'Times New Roman', Times, serif;
  font-family: Arial, Helvetica, sans-serif;*/
  font-weight: bold;
}

.process {
  padding: 0 20px;
}
</style>
<style scoped>
.process >>> .el-step__title {
  font-size: 12px !important;
}

</style>
